import React from 'react';

export const NoMatch = () => {
    return <h1>{'404 - Whoopsie'}</h1>;
};
